import React, { useContext } from "react";
import { IonCard, useIonAlert } from "@ionic/react";
import CardFilter from "./CardFilter";
import CardInfo from "./CardInfo";
import { QueryResult } from "../hooks/useQueryExec";
import { encodeParam } from "../util/ApiHelper";
import { TranslationMessagesContext } from "../util/Translations";
import { SelectedWo, WoCardData } from "../models/workorders/WorkOrder";

type Props = {
  filteredRows: QueryResult[];
  isSelectable?: boolean;
  onToggle?: (cardData: SelectedWo) => void;
  hideFilter?: boolean;
  onFilter: (queryString: string) => Promise<void>;
  filterString: string;
  onQueryRowClick?: (row: QueryResult) => void;
  selectedWoIds?: string[];
} & WoCardData;

const WorkOrderCard: React.FC<Props> = ({
  filteredRows,
  isSelectable,
  onToggle,
  hideFilter,
  allRows,
  filterString,
  storesTab,
  woLink,
  storesRoute,
  onFilter,
  onQueryRowClick,
  selectedWoIds,
}) => {
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [presentAlert] = useIonAlert();

  const handleClick = (row: QueryResult) => {
    if (!row.HeaderValue) {
      presentAlert(
        translatedMessages["QWColumnMissing"]?.MessageText.replace(
          "@1",
          row.HeaderValue
        ) ||
          `Cannot continue with this request. The column ${row.HeaderValue} is not selected in the query. Please rebuild the query and select this column.`
      );
      return;
    }
    onQueryRowClick?.(row);
  };

  const getRouterLink = (row: QueryResult) => {
    if (!row.HeaderValue) return undefined;
    return storesRoute
      ? `/workorder/${encodeParam(row.HeaderValue)}/${storesTab}material`
      : `${woLink}/${encodeParam(row.HeaderValue)}`;
  };

  const getCardStyle = (row: QueryResult) =>
    row.HeaderColor
      ? {
          borderColor: row.HeaderColor,
          borderLeftStyle: "solid",
          borderLeftWidth: "5px",
        }
      : {};

  return (
    <>
      <CardFilter
        hideFilter={hideFilter}
        queryRows={allRows}
        resultsFilter={filterString}
        filterMethod={onFilter}
      />
      {filteredRows.map((row) => (
        <IonCard
          style={getCardStyle(row)}
          key={row.HeaderRow}
          routerLink={getRouterLink(row)}
          onClick={() => handleClick(row)}
        >
          <CardInfo
            isSelectable={isSelectable}
            header={row.HeaderValue}
            columns={row.Columns}
            isSelected={selectedWoIds?.some((s) => s === row.HeaderValue)}
            onToggle={(id: string) => {
              onToggle?.({
                row,
                woLink,
                storesRoute,
                storesTab,
                id,
              });
            }}
          />
        </IonCard>
      ))}
    </>
  );
};

export default WorkOrderCard;
